export const ISetTipOptionUseCaseType = Symbol('ISetTipOptionUseCase');
